var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui middle aligned center aligned grid" },
    [
      _vm.showForm
        ? _c("div", { staticClass: "column" }, [
            _vm.showSuccessMessage
              ? _c(
                  "div",
                  { staticClass: "ui success message" },
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("pages.register.form.success")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "usersetup" } } },
                      [_vm._v(_vm._s(_vm.$t("pages.register.redirectlink")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ui blue header centered" }, [
              _c("div", { staticClass: "content" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("pages.register.header")) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "ui large form",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.sendForm.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "ui stacked segment" }, [
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: { error: _vm.errors.has("email") }
                    },
                    [
                      _c("div", { staticClass: "ui input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email",
                              expression: "'required|email'"
                            }
                          ],
                          attrs: {
                            type: "email",
                            "data-vv-as": _vm.$t("pages.register.form.email"),
                            name: "email",
                            placeholder: _vm.$t("pages.register.form.email"),
                            readonly: ""
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.has("email")
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(_vm._s(_vm.errors.first("email")))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: { error: _vm.errors.has("password") }
                    },
                    [
                      _c("div", { staticClass: "ui input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "passwordRef",
                          attrs: {
                            type: "password",
                            "data-vv-as": _vm.$t(
                              "pages.register.form.password"
                            ),
                            name: "password",
                            placeholder: _vm.$t("pages.register.form.password")
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.has("password")
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(_vm._s(_vm.errors.first("password")))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: { error: _vm.errors.has("password_confirmation") }
                    },
                    [
                      _c("div", { staticClass: "ui input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password_confirmation,
                              expression: "password_confirmation"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|confirmed:passwordRef",
                              expression: "'required|confirmed:passwordRef'"
                            }
                          ],
                          attrs: {
                            type: "password",
                            "data-vv-as": _vm.$t(
                              "pages.register.form.password_confirmation"
                            ),
                            name: "password_confirmation",
                            placeholder: _vm.$t(
                              "pages.register.form.password_confirmation"
                            )
                          },
                          domProps: { value: _vm.password_confirmation },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password_confirmation = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.has("password_confirmation")
                        ? _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              _vm._s(_vm.errors.first("password_confirmation"))
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "field",
                      class: { error: _vm.errors.has("terms") }
                    },
                    [
                      _c("div", { staticClass: "ui checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.acceptingTerms,
                              expression: "acceptingTerms"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            name: "terms",
                            "data-vv-as": _vm.$t(
                              "pages.register.form.termsandconds"
                            ),
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.acceptingTerms)
                              ? _vm._i(_vm.acceptingTerms, null) > -1
                              : _vm.acceptingTerms
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.acceptingTerms,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.acceptingTerms = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.acceptingTerms = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.acceptingTerms = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("pages.register.form.i_accept")) + " "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.showTerms = !_vm.showTerms
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("pages.register.form.termsandconds")
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.errors.has("terms")
                          ? _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(_vm.errors.first("terms")))
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ui large fluid blue button",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pages.register.form.button")) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "semantic-modal",
        {
          staticClass: "large",
          attrs: {
            settings: {
              content_classes: { content: true },
              closeable: false,
              closeable_button: false
            }
          },
          model: {
            value: _vm.showTerms,
            callback: function($$v) {
              _vm.showTerms = $$v
            },
            expression: "showTerms"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "ui header",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("modals.termsandconds.accept_header")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("user-terms"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "actions",
              attrs: { slot: "actions" },
              slot: "actions"
            },
            [
              _c(
                "div",
                {
                  staticClass: "ui red deny button",
                  on: {
                    click: function($event) {
                      _vm.acceptingTerms = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("globals.buttons.no")))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ui ok green button",
                  on: {
                    click: function($event) {
                      _vm.acceptingTerms = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("globals.buttons.accept")))]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bca47f12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bca47f12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/UserRegistration.vue
// module id = lpDS
// module chunks = 1